<script lang="ts">
  import { Icon } from '@centerhealth/fe/center-kit';
  import { SvgTypes } from '@centerhealth/fe/center-kit';

  export let customClass = '';
  export let btnText = 'Help';
  export let svgName: SvgTypes = 'chat-beacon';

  let showBtn = true;
  let loadingScript = false;

  interface WindowBeacon extends Window {
    Beacon?: (val1: string, val2?: string) => void;
  }

  let win: WindowBeacon;

  // Callback when Beacon is loaded
  const beaconLoaded = () => {
    // Power up the real scout button and remove facade
    showBtn = false;
    loadingScript = false;
  };

  const initHelpScout = () => {
    win = window;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fn = function (e: any, t: Document, n: any) {
      function a(): void {
        const e: HTMLScriptElement = t.getElementsByTagName('script')[0],
          n: HTMLScriptElement = t.createElement('script');
        n.type = 'text/javascript';
        n.async = true;
        n.src = 'https://beacon-v2.helpscout.net';
        e.parentNode.insertBefore(n, e);
      }
      if (
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        ((e.Beacon = n =
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          function (t: string, n: any, a: any) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
            e.Beacon.readyQueue.push({ method: t, options: n, data: a });
          }),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        (n.readyQueue = []),
        'complete' === t.readyState)
      ) {
        loadingScript = true;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
        e.Beacon('on', 'open', beaconLoaded);
        return a();
      }
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
      e.attachEvent ? e.attachEvent('onload', a) : e.addEventListener('load', a, !1);
    };
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    fn(window, document, win.Beacon || (() => {}));
  };

  const handleOpenHelpScout = () => {
    win = window;
    // initialize help scout
    if (win.Beacon && !showBtn) {
      return;
    }

    initHelpScout();

    win.Beacon('init', '2c642039-d9bd-41f7-b1b7-c9256655f1a8');
    win.Beacon('open');
  };
</script>

{#if showBtn}
  <button
    class={`scout-beacon-btn-clone ${customClass}`}
    type="button"
    disabled={loadingScript}
    on:click={handleOpenHelpScout}
  >
    <img
      class="loader-icon"
      width="20"
      height="20"
      class:show-loader={loadingScript}
      src="/assets/loaders/light.svg"
      alt=""
    />
    {#if !loadingScript}
      <Icon {svgName} type="svg" />
      {btnText}
    {/if}
  </button>
{/if}

<style lang="scss">
  .scout-beacon-btn-clone {
    @apply flex justify-center rounded-[55px] cursor-pointer py-[15px] bottom-[10px] right-[20px] md:bottom-[40px] md:right-[40px] px-[20px] text-white gap-[10px] font-semibold text-xs min-w-[104.35px] min-h-[55px];
    --BlueConfigGlobalFontFamilyMono: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier,
      monospace;
    --HSDSGlobalFontFamily: -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial,
      sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
    -webkit-font-smoothing: antialiased;
    font-family: var(--HSDSGlobalFontFamily);
    position: fixed;
    background: rgb(0, 170, 255);
    z-index: 9999;

    &:disabled {
      background: rgb(0, 170, 255);
    }
  }

  .loader-icon {
    height: 20px;
    width: 20px;
    display: none;

    &.show-loader {
      display: block;
    }
  }
</style>
